import PropTypes from "prop-types";
import "../../assets/styles/colors.css";

function ChatHistorySidebar({
  open,
  onClose,
  sessions,
  selectedSessionId,
  onSessionSelect,
  onSessionDelete,
  t,
}) {
  return (
    <div
      className={`fixed inset-0 z-50 transition-all duration-300 ${open ? "visible" : "invisible pointer-events-none"
        }`}
      style={{ background: open ? "var(--color-bg-overlay)" : "transparent" }}
      onClick={onClose}
    >
      <aside
        className={`absolute left-0 top-0 h-full w-80 max-w-full border-r border-[var(--color-border)] shadow-2xl transition-transform duration-300 bg-[var(--color-bg-card)] dark:bg-[var(--color-bg-darkest)] ${open ? "translate-x-0" : "-translate-x-full"
          }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-[var(--color-border)] bg-[var(--color-bg-card)] dark:bg-[var(--color-bg-darkest)]">
          <span className="text-sm font-semibold text-[var(--color-text-primary)]">
            {t("Chat History")}
          </span>
          <button
            onClick={onClose}
            className="p-1 text-[var(--color-text-muted)] hover:text-[var(--color-text-primary)] hover:bg-[var(--color-primary)]/10 rounded-full"
            title={t("Close")}
          >
            ✕
          </button>
        </div>
        <div className="p-4 overflow-y-auto h-[calc(100vh-56px)]">
          {sessions.length === 0 ? (
            <div className="text-sm italic text-[var(--color-text-muted)]">
              {t("No chats yet. Send a message to start one.")}
            </div>
          ) : (
            <ul className="space-y-2">
              {sessions.map((s, index) => {
                const isSelected = s.id === selectedSessionId;
                return (
                  <li
                    key={s.id}
                    onClick={() => onSessionSelect?.(s.id)}
                    className={`group flex items-center gap-2 cursor-pointer rounded-lg px-3 py-2 transition-all border-l-2 ${isSelected
                      ? "bg-[var(--color-primary)]/10 text-[var(--color-text-primary)] border-l-[var(--color-primary)]"
                      : "bg-[var(--color-bg-darker)]/80 text-[var(--color-text-muted)] border-l-[var(--color-border)] hover:bg-[var(--color-primary)]/10 hover:border-l-[var(--color-primary)]/50 hover:text-[var(--color-text-primary)]"
                      }`}
                  >
                    <span className="flex-shrink-0 w-6 text-xs font-bold text-[var(--color-primary)]">
                      {sessions.length - index}
                    </span>
                    <span className="flex-1 truncate text-sm font-medium">
                      {s.title}
                    </span>
                    {onSessionDelete && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          onSessionDelete(s.id, e);
                        }}
                        className="text-[var(--color-error)] hover:text-[var(--color-error-hover)] p-0.5 rounded hover:bg-[var(--color-error)]/10 dark:hover:bg-red-900/30 transition-opacity"
                        title={t("Delete chat")}
                      >
                        <svg
                          className="w-3 h-3"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth={1.5}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                          />
                        </svg>
                      </button>
                    )}
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </aside>
    </div>
  );
}

ChatHistorySidebar.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  sessions: PropTypes.array.isRequired,
  selectedSessionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSessionSelect: PropTypes.func,
  onSessionDelete: PropTypes.func,
  t: PropTypes.func.isRequired,
};

export default ChatHistorySidebar;
